/* tslint:disable */
import {
  KanvasUser,
  Player
} from '../index';

declare var Object: any;
export interface AddressInterface {
  "id": string;
  "AddressType": string;
  "LocationName": string;
  "Address1": string;
  "Address2"?: string;
  "Address3"?: string;
  "City": string;
  "State": string;
  "Zip": string;
  "kanvasUserId"?: string;
  "playerId"?: string;
  "BillingAddressId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  kanvasUser?: KanvasUser;
  player?: Player;
}

export class Address implements AddressInterface {
  "id": string;
  "AddressType": string;
  "LocationName": string;
  "Address1": string;
  "Address2": string;
  "Address3": string;
  "City": string;
  "State": string;
  "Zip": string;
  "kanvasUserId": string;
  "playerId": string;
  "BillingAddressId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  kanvasUser: KanvasUser;
  player: Player;
  constructor(data?: AddressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Address`.
   */
  public static getModelName() {
    return "Address";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Address for dynamic purposes.
  **/
  public static factory(data: AddressInterface): Address{
    return new Address(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Address',
      plural: 'Addreses',
      path: 'Addreses',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "AddressType": {
          name: 'AddressType',
          type: 'string'
        },
        "LocationName": {
          name: 'LocationName',
          type: 'string'
        },
        "Address1": {
          name: 'Address1',
          type: 'string'
        },
        "Address2": {
          name: 'Address2',
          type: 'string'
        },
        "Address3": {
          name: 'Address3',
          type: 'string'
        },
        "City": {
          name: 'City',
          type: 'string'
        },
        "State": {
          name: 'State',
          type: 'string'
        },
        "Zip": {
          name: 'Zip',
          type: 'string'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "playerId": {
          name: 'playerId',
          type: 'string'
        },
        "BillingAddressId": {
          name: 'BillingAddressId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Address.ts